// extracted by mini-css-extract-plugin
export default {"whiteBorderBtn":"cancelBtn_whiteBorderBtn__D+Vjf"};